export const AdminRoutes = {
  path: 'admin/*',
  lazy: () => import('../pages/admin'),
  children: [
    {
      path: 'api-access',
      lazy: () => import('../pages/admin/api-access'),
    },
  ],
};
